
import { defineComponent } from 'vue'
import { templateEndpointComposition } from '@/core/modules/templates/services';
import { pdfEndpointComposition } from '@/core/modules/pdfViewer/services';

import PdfViewer from '@/core/modules/pdfViewer/components/pdf-viewer.vue';

export default defineComponent({
    components: {
        PdfViewer
    },
    setup() {
        return { ...templateEndpointComposition(), ...pdfEndpointComposition() }
    },
})
